import {
  getStandardWatermarkAttributes,
  getWatermarkConfig
} from '@/features/charts/hooks/options/useChartFunctions';
import type { ChartAppearance } from '@/features/charts/theme/chartAppearance';

import type { FullscreenWatermarkChart } from './fullScreenChartTypes';

const createWatermarkImage = (chart: FullscreenWatermarkChart, appearance: ChartAppearance) => {
  const watermark = getWatermarkConfig(appearance.watermark);
  return chart.renderer.image(watermark.dataUri).addClass('gx-fullscreen-watermark').add();
};

export const applyFullscreenWatermarkLayout = (
  chart: FullscreenWatermarkChart,
  appearance: ChartAppearance,
  useSmallWatermark = false
): void => {
  const watermarks = (chart.fullscreenWatermarks ??= {});
  const image = (watermarks[appearance.watermark] ??= createWatermarkImage(chart, appearance));
  const watermark = getWatermarkConfig(appearance.watermark);

  const attrs = getStandardWatermarkAttributes({
    chart,
    aspectRatio: watermark.aspectRatio,
    useSmallWatermark
  });

  Object.entries(watermarks).forEach(([watermarkPath, watermarkImage]) => {
    watermarkImage?.attr({
      visibility: watermarkPath === appearance.watermark ? 'visible' : 'hidden'
    });
  });

  image.attr({ height: attrs.height, width: attrs.width, zIndex: attrs.zIndex });
  image.align(
    {
      align: attrs.align ?? 'right',
      verticalAlign: attrs.verticalAlign ?? 'bottom',
      x: attrs.x,
      y: attrs.y
    },
    false,
    'plotBox'
  );
};
